import { type QueryHookOptions, useQuery } from "@apollo/client";
import { PostQuery } from "../graphql/queries";
import type { PostQueryType } from "@/types/graphql/partner.generated";

export const usePostQuery = (options?: QueryHookOptions<PostQueryType>) => {
  return useQuery<PostQueryType>(PostQuery, options);
};
